var render = function render(){
  var _vm$refundRequest$ref;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.$bvModal.show(`refundRequest-confirm-approve-${_vm.edit}-${_vm.refundRequest.id}`);
      }
    }
  }, [_c('b-card', {
    staticClass: "dispatchRequest mb-4 mt-1 font-size-md",
    class: {
      'opacity-7': _vm.history && _vm.refundRequest.is_replaced,
      'opacity-2': _vm.isChanged
    },
    attrs: {
      "no-body": "",
      "data-refund-request-id": _vm.refundRequest.id
    }
  }, [_c('b-card-header', {
    attrs: {
      "header-bg-variant": "light"
    }
  }, [_c('b-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12",
      "xl": "3"
    }
  }, [_c('h5', {
    staticClass: "mb-0 d-inline align-bottom"
  }, [_c('span', {
    attrs: {
      "title": _vm.refundRequest.status
    }
  }, [_c('refund-request-icon', {
    staticClass: "mr-2",
    attrs: {
      "status": _vm.refundRequest.status
    }
  })], 1)]), _c('h6', {
    staticClass: "mb-0 d-inline"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("uppercase")(_vm._f("refundRequestStatus")(_vm.refundRequest.status))))]), _vm.refundRequest.status === 'proposal' ? _c('small', {
    staticClass: "d-inline-block pl-2"
  }, [_vm._v(" (Leveringsstatus: " + _vm._s(_vm._f("dispatchRequestStatus")(_vm.refundRequest.dispatch_request.status)) + ") ")]) : _vm._e()])]), _c('b-col', {
    attrs: {
      "cols": "12",
      "xl": "3"
    }
  }, [!_vm.edit ? _c('h5', {
    staticClass: "mb-0"
  }, [_c('small', [_c('strong', [_vm._v("Gemaakt op: ")]), _c('span', [_vm._v(_vm._s(_vm._f("datetimeshort")(_vm.refundRequest.created_at)))])])]) : _vm._e()]), _c('b-col', {
    attrs: {
      "cols": "12",
      "xl": "3"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_c('small', {
    staticClass: "ml-2"
  }, [_vm.refundAmountExceedsBudget(_vm.editableRefundRequest) ? _c('span', [_c('FontAwesomeIcon', {
    staticClass: "text-danger mr-2",
    attrs: {
      "icon": "warning",
      "title": "Het bedrag van creditering is hoger dan het beschikbare budget"
    }
  })], 1) : _vm._e(), _vm.showBudget(_vm.editableRefundRequest) ? _c('span', [_c('strong', [_vm._v("Budget: ")]), _c('span', [_vm._v(" " + _vm._s(_vm._f("price")(this.refundRequest.total_refundable_amount)) + " ")])]) : _c('span', [_c('strong', [_vm._v("Crediteren: ")]), isNaN(_vm.totalRefundAmount) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Foute invoer")]) : _c('span', [_vm._v(_vm._s(_vm._f("price")(_vm.totalRefundAmount)))])])])])]), _c('b-col', {
    attrs: {
      "cols": _vm.history ? 3 : 2
    }
  }, [_c('h5', {
    staticClass: "mb-0",
    class: {
      blur: _vm.shouldBlur
    }
  }, [_vm.refundRequest.status === 'decision-denied-final' ? _c('small', {
    staticClass: "text-danger"
  }, [_c('strong', [_vm._v("Terugbetaald: ")]), _c('span', [_vm._v("0,00")])]) : _vm.refundRequest.status === 'refunded' ? _c('small', {
    staticClass: "text-success"
  }, [_c('strong', [_vm._v("Terugbetaald: ")]), _c('span', [_vm._v(_vm._s(_vm._f("price")(_vm.totalRefundAmount)))])]) : _vm._e()])]), !_vm.edit && !_vm.history ? _c('b-col', {
    staticClass: "text-center text-lg-right pr-0 mt-3 mt-lg-0",
    attrs: {
      "cols": "12",
      "xl": "1"
    }
  }, [_c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm",
      "title": "Bekijk geschiedenis",
      "disabled": _vm.isSaving
    },
    on: {
      "click": function ($event) {
        return _vm.$bvModal.show(`showRefundRequestHistory-${_vm.refundRequest.id}`);
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "eye"
    }
  })], 1), _vm.isEditable && _vm.refundRequest.status === 'proposal' ? _c('span', [_c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm",
      "title": "Wijzigen",
      "disabled": _vm.isSaving
    },
    on: {
      "click": function ($event) {
        return _vm.$bvModal.show(`editRefundRequest_${_vm.refundRequest.id}`);
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "edit"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1), _vm.refundRequest.metadata && _vm.refundRequest.metadata.release_time ? _c('b-alert', {
    staticClass: "mb-0",
    attrs: {
      "show": "",
      "variant": "secondary"
    }
  }, [_vm._v(" Deze creditering wordt automatisch verwerkt op: " + _vm._s(_vm._f("datetime")(_vm.refundRequest.metadata.release_time)) + " ")]) : _vm._e(), !_vm.refundRequest.refund_method_id ? _c('b-alert', {
    staticClass: "mb-0",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_c('strong', [_vm._v("Let op:")]), _vm._v(" Deze creditering heeft geen terugbetalingsmethode ingesteld. Neem contact op met OmniStock. ")]) : _vm._e(), _vm.refundRequest.metadata && !!_vm.refundRequest.metadata.caused_by_trigger_id ? _c('b-alert', {
    staticClass: "mb-0",
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [!_vm.trigger ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('span', [_c('strong', [_vm._v("Let op:")]), _vm._v(" De actie "), _c('i', [_vm._v("\"" + _vm._s(_vm.trigger.actions[0].action_component_display_name) + "\"")]), _vm._v(" is uitgevoerd omdat de creditering voldoet aan deze controles: "), _c('ul', {
    staticClass: "m-0 mt-2 pl-4"
  }, _vm._l(_vm.relevantTriggerConditions, function (condition) {
    return _c('li', [_vm._v(" " + _vm._s(condition.condition_class_display_name) + " " + _vm._s(condition.operator) + " " + _vm._s(condition.value) + " ")]);
  }), 0)])], 1) : _vm._e(), _c('b-card-body', {
    staticClass: "pl-4 pb-3 pt-4",
    class: {
      blur: _vm.shouldBlur
    },
    attrs: {
      "body-bg-variant": "default"
    }
  }, [_vm.refundRequest.refund_request_lines ? _c('b-table-simple', {
    attrs: {
      "small": "",
      "borderless": "",
      "responsive": ""
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "40%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  })]), _c('b-thead', [_c('b-tr', [_c('b-th', [_vm._v("Artikel nr")]), _c('b-th', [_vm._v("Productnaam")]), _c('b-th', [_vm._v("Aantal")]), _c('b-th', [_vm._v("Stuksprijs")]), _c('b-th', [_vm._v("Regelprijs")]), _c('b-th', [_vm._v("Terugbetaling")]), _vm.showLineBudget(_vm.refundRequest) ? _c('b-th', [_vm._v("Beschikbaar Budget")]) : _c('b-th')], 1)], 1), _c('b-tbody', _vm._l(_vm.flattenedLines, function (line) {
    var _line$refundLine, _line$refundLineAddit, _line$refundLine$disp, _line$refundLine$disp2, _line$refundLine$disp3, _line$refundLine$disp4, _line$refundLine$disp5, _line$refundLine$disp6;
    return _c('b-tr', {
      attrs: {
        "data-refund-request-line-id": (_line$refundLine = line.refundLine) === null || _line$refundLine === void 0 ? void 0 : _line$refundLine.id,
        "data-refund-request-line-addition-id": (_line$refundLineAddit = line.refundLineAddition) === null || _line$refundLineAddit === void 0 ? void 0 : _line$refundLineAddit.id
      }
    }, [_c('b-td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(line.product_identifier))]), _c('b-td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(line.product_name))]), _c('b-td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(line.quantity))]), _c('b-td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(_vm._f("price")(line.piece_price)))]), _c('b-td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(_vm._f("price")(line.line_price)))]), _c('b-td', {
      staticClass: "align-middle"
    }, [line.refundLineAddition && !_vm.edit ? _c('span', [_vm._v(_vm._s(_vm._f("price")(line.refundLineAddition.refund_amount)))]) : !line.refundLineAddition && !_vm.edit ? _c('span', [_vm._v(_vm._s(_vm._f("price")(line.refundLine.refund_amount)))]) : line.refundLineAddition ? _c('b-input', {
      staticClass: "d-inline-block",
      class: {
        'border-warning': _vm.refundLineAdditionAmountExceedsBudget(line)
      },
      staticStyle: {
        "width": "calc(100% - 5px)"
      },
      attrs: {
        "size": "sm",
        "type": "number",
        "min": "0",
        "max": line.total_refundable_amount,
        "step": "any",
        "data-line-gross-price": (_line$refundLine$disp = line.refundLine.dispatch_request_line) === null || _line$refundLine$disp === void 0 ? void 0 : (_line$refundLine$disp2 = _line$refundLine$disp.sales_order_line) === null || _line$refundLine$disp2 === void 0 ? void 0 : _line$refundLine$disp2.line_gross_price
      },
      model: {
        value: line.refundLineAddition.refund_amount,
        callback: function ($$v) {
          _vm.$set(line.refundLineAddition, "refund_amount", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "line.refundLineAddition.refund_amount"
      }
    }) : _c('b-input', {
      staticClass: "d-inline-block",
      class: {
        'border-warning': line.refundLine.refund_amount > ((_line$refundLine$disp3 = line.refundLine.dispatch_request_line) === null || _line$refundLine$disp3 === void 0 ? void 0 : (_line$refundLine$disp4 = _line$refundLine$disp3.sales_order_line) === null || _line$refundLine$disp4 === void 0 ? void 0 : _line$refundLine$disp4.line_gross_price) || line.refundLine.refund_amount < 0
      },
      staticStyle: {
        "width": "calc(100% - 5px)"
      },
      attrs: {
        "size": "sm",
        "type": "number",
        "min": "0",
        "max": line.total_refundable_amount,
        "step": "any",
        "data-line-gross-price": (_line$refundLine$disp5 = line.refundLine.dispatch_request_line) === null || _line$refundLine$disp5 === void 0 ? void 0 : (_line$refundLine$disp6 = _line$refundLine$disp5.sales_order_line) === null || _line$refundLine$disp6 === void 0 ? void 0 : _line$refundLine$disp6.line_gross_price
      },
      model: {
        value: line.refundLine.refund_amount,
        callback: function ($$v) {
          _vm.$set(line.refundLine, "refund_amount", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "line.refundLine.refund_amount"
      }
    })], 1), _vm.showLineBudget(_vm.refundRequest) ? _c('b-td', {
      staticClass: "align-middle"
    }, [line.refundLineAddition ? _c('span', [_vm.refundLineAdditionAmountExceedsBudget(line) ? _c('FontAwesomeIcon', {
      staticClass: "text-danger mr-1",
      attrs: {
        "icon": "warning",
        "title": "Het bedrag van de regel is hoger dan het beschikbare budget"
      }
    }) : _vm._e(), line.refundLineAddition.refund_amount === '' ? _c('FontAwesomeIcon', {
      staticClass: "text-danger mr-1",
      attrs: {
        "icon": "warning",
        "title": "Ongeldige invoer"
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("price")(line.refundLineAddition.total_refundable_amount)) + " ")], 1) : _c('span', [_vm.refundLineAmountExceedsBudget(_vm.editableRefundRequest, line) ? _c('FontAwesomeIcon', {
      staticClass: "text-danger mr-1",
      attrs: {
        "icon": "warning",
        "title": "Het bedrag van de regel is hoger dan het beschikbare budget"
      }
    }) : _vm._e(), line.refundLine.refund_amount === '' ? _c('FontAwesomeIcon', {
      staticClass: "text-danger mr-1",
      attrs: {
        "icon": "warning",
        "title": "Ongeldige invoer"
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("price")(line.total_refundable_amount)) + " ")], 1)]) : _c('b-td')], 1);
  }), 1)], 1) : _vm._e(), _vm.editableRefundRequest.refund_request_additions && _vm.editableRefundRequest.refund_request_additions.length ? _c('b-table-simple', {
    attrs: {
      "small": "",
      "borderless": ""
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "80%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  })]), _c('b-thead', [_c('b-tr', [_c('b-th', [_vm._v("Toevoeging")]), _c('b-th', [_vm._v("Terugbetaling")]), _c('b-th')], 1)], 1), _c('b-tbody', _vm._l(_vm.editableRefundRequest.refund_request_additions, function (refundRequestAddition) {
    return _c('b-tr', [_c('b-td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(refundRequestAddition.reason))]), _c('b-td', {
      staticClass: "align-middle"
    }, [!_vm.edit ? _c('span', [_vm._v(_vm._s(_vm._f("price")(refundRequestAddition.amount)))]) : _c('b-input', {
      staticClass: "d-inline-block w-75",
      class: {
        'border-danger': refundRequestAddition.refund_amount < 0
      },
      attrs: {
        "size": "sm",
        "type": "number",
        "min": "0",
        "step": "any"
      },
      model: {
        value: refundRequestAddition.amount,
        callback: function ($$v) {
          _vm.$set(refundRequestAddition, "amount", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "refundRequestAddition.amount"
      }
    })], 1), _vm.showLineBudget(_vm.refundRequest) ? _c('b-td', {
      staticClass: "align-middle"
    }, [_vm.refundAdditionAmountExceedsBudget(refundRequestAddition) ? _c('FontAwesomeIcon', {
      staticClass: "text-danger mr-1",
      attrs: {
        "icon": "warning",
        "title": "Het bedrag van de regel is hoger dan het beschikbare budget"
      }
    }) : _vm._e(), refundRequestAddition.amount === '' ? _c('FontAwesomeIcon', {
      staticClass: "text-danger ml-2",
      attrs: {
        "icon": "warning",
        "title": "Ongeldige invoer"
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("price")(refundRequestAddition.total_refundable_amount)) + " ")], 1) : _c('b-td')], 1);
  }), 1)], 1) : _vm._e(), _c('b-table-simple', {
    attrs: {
      "small": "",
      "borderless": ""
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "80%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  })]), _c('b-thead', [_c('b-tr', [_c('b-th', [_vm._v("Totaal")]), _c('b-th', [_vm._v(" Terugbetaling "), _c('span', {
    staticClass: "font-weight-normal"
  }, [_vm._v("(via: " + _vm._s((_vm$refundRequest$ref = _vm.refundRequest.refund_method) === null || _vm$refundRequest$ref === void 0 ? void 0 : _vm$refundRequest$ref.display_name) + ")")])])], 1)], 1), _c('b-tbody', [_c('b-tr', [_c('b-td', [_vm._v("Totaal")]), _c('b-td', [_vm.refundAmountExceedsBudget(_vm.refundRequest) ? _c('span', [_c('FontAwesomeIcon', {
    staticClass: "text-danger mr-2",
    attrs: {
      "icon": "warning",
      "title": "Het bedrag van creditering is hoger dan het beschikbare budget"
    }
  })], 1) : _vm._e(), isNaN(_vm.totalRefundAmount) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Foute invoer")]) : _c('span', [_vm._v(_vm._s(_vm._f("price")(_vm.totalRefundAmount)))])])], 1)], 1)], 1)], 1), _c('b-card-footer', {
    class: {
      'pb-0': !_vm.isEditable
    },
    attrs: {
      "footer-bg-variant": "light",
      "footer-border-variant": "light"
    }
  }, [_c('b-col', {
    staticClass: "pr-4 pl-0 text-black-50",
    attrs: {
      "cols": "10"
    }
  }, [!_vm.shouldBlur ? _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('div', {
    staticClass: "pr-2"
  }, [_vm.isEditable.comment || _vm.canComment ? _c('strong', [_vm._v("Opmerking:")]) : _vm._e(), !_vm.canComment ? _c('span', [_vm._v(" " + _vm._s(_vm.refundRequest.comment))]) : _vm._e()]), _c('div', {
    staticClass: "flex-fill"
  }, [_vm.canComment ? _c('b-textarea', {
    class: {
      'border-danger': _vm.$store.state.config.refunds['require-comment'] && !_vm.editableRefundRequest.comment
    },
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "size": "sm",
      "required": _vm.$store.state.config.refunds['require-comment']
    },
    model: {
      value: _vm.editableRefundRequest.comment,
      callback: function ($$v) {
        _vm.$set(_vm.editableRefundRequest, "comment", $$v);
      },
      expression: "editableRefundRequest.comment"
    }
  }) : _vm._e()], 1)]) : _vm.refundRequest.status === 'refund-to-be-processed-manually' && !_vm.history ? _c('h5', {
    staticClass: "text-info mb-0"
  }, [_vm._v(" Vergrendel deze creditering om details te zien ")]) : _vm.refundRequest.status === 'refund-processing-manually' && !_vm.isRefundRequestFromCurrentUser ? _c('h5', {
    staticClass: "text-info mb-0"
  }, [_vm._v(" Deze handmatige uitbetaling wordt al door " + _vm._s(_vm.refundRequest.user_id ? _vm.refundRequest.user.name : 'systeem') + " uitgevoerd ")]) : _vm._e()]), _vm.isEditable ? _c('b-col', {
    staticClass: "text-right pr-0",
    attrs: {
      "cols": "2"
    }
  }, [_vm.refundRequest.status === 'proposal' ? _c('span', [_c('b-button', {
    staticClass: "float-right ml-2",
    attrs: {
      "type": "submit",
      "variant": "success",
      "size": "lg",
      "disabled": !_vm.isApprovable(_vm.editableRefundRequest) || _vm.isSaving,
      "title": !this.edit ? `Goedkeuren` : `Opslaan en goedkeuren`
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "thumbs-up"
    }
  })], 1), _vm.isDenyable ? _c('b-button', {
    staticClass: "float-right ml-2",
    attrs: {
      "type": "button",
      "variant": "danger",
      "size": "lg",
      "title": "Weigeren",
      "disabled": !_vm.isDenyable || _vm.isSaving
    },
    on: {
      "click": function ($event) {
        return _vm.$bvModal.show(`refundRequest-confirm-deny-${_vm.edit}-${_vm.refundRequest.id}`);
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "ban"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm.refundRequest.status === 'refund-to-be-processed-manually' ? _c('span', [_c('b-button', {
    staticClass: "float-right ml-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "size": "lg",
      "title": "Vergrendel",
      "disabled": _vm.isSaving
    },
    on: {
      "click": function ($event) {
        return _vm.lock();
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "lock-open"
    }
  })], 1)], 1) : _vm._e(), _vm.refundRequest.status === 'refund-processing-manually' && _vm.isRefundRequestFromCurrentUser ? _c('span', [_c('b-button', {
    staticClass: "float-right ml-2",
    attrs: {
      "type": "button",
      "variant": "success",
      "size": "lg",
      "title": "Verwerkt",
      "disabled": _vm.isSaving
    },
    on: {
      "click": function ($event) {
        return _vm.$bvModal.show(`refundRequest-confirm-confirm-refund-to-be-processed-manually-${_vm.edit}-${_vm.refundRequest.id}`);
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "check"
    }
  })], 1), _c('b-button', {
    staticClass: "float-right ml-2",
    attrs: {
      "type": "button",
      "variant": "primary",
      "size": "lg",
      "title": "Ontgrendel",
      "disabled": _vm.isSaving
    },
    on: {
      "click": function ($event) {
        return _vm.unlock();
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "lock"
    }
  })], 1)], 1) : _vm._e(), _vm.refundRequest.status === 'proposal-to-be-released-automatically' ? _c('span', [_c('b-button', {
    staticClass: "float-right ml-2",
    attrs: {
      "type": "button",
      "variant": "outline-success",
      "size": "md",
      "title": "Nu verwerken",
      "disabled": _vm.isSaving
    },
    on: {
      "click": function ($event) {
        return _vm.$bvModal.show(`refundRequest-confirm-release-automatic-processing-${_vm.edit}-${_vm.refundRequest.id}`);
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "thumbs-up"
    }
  })], 1), _c('b-button', {
    staticClass: "float-right ml-2",
    attrs: {
      "type": "button",
      "variant": "outline-info",
      "size": "md",
      "title": "Zet terug naar 'te accorderen'",
      "disabled": _vm.isSaving
    },
    on: {
      "click": function ($event) {
        return _vm.$bvModal.show(`refundRequest-confirm-cancel-automatic-processing-${_vm.edit}-${_vm.refundRequest.id}`);
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "undo"
    }
  })], 1)], 1) : _vm._e()]) : _vm._e()], 1), !_vm.isEditable ? _c('b-card-footer', {
    staticClass: "pt-0",
    attrs: {
      "footer-bg-variant": "light",
      "footer-border-variant": "light"
    }
  }, [_c('b-col', {
    staticClass: "pr-0 text-black-50 pl-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('small', [_c('strong', [_vm._v("Gewijzigd door:")]), _vm._v(" " + _vm._s(_vm.refundRequest.user_id ? _vm.refundRequest.user.name : 'systeem'))])])], 1) : _vm._e()], 1), !_vm.edit ? _c('b-modal', {
    attrs: {
      "id": `editRefundRequest_${_vm.refundRequest.id}`,
      "size": "xl",
      "title": "Creditering accorderen",
      "centered": "",
      "dialog-class": "shadow-none",
      "footer-class": "d-none"
    }
  }, [_c('refund-request', {
    attrs: {
      "refund-request": _vm.refundRequest,
      "edit": true
    },
    on: {
      "close": function ($event) {
        return _vm.$bvModal.hide(`editRefundRequest_${_vm.refundRequest.id}`);
      },
      "changed": function ($event) {
        return _vm.$emit('changed');
      }
    }
  })], 1) : _vm._e(), !_vm.edit ? _c('b-modal', {
    attrs: {
      "id": `showRefundRequestHistory-${_vm.refundRequest.id}`,
      "size": "xl",
      "title": "Creditering's geschiedenis",
      "centered": "",
      "dialog-class": "shadow-none",
      "footer-class": "d-none"
    },
    on: {
      "show": _vm.loadHistory
    }
  }, [_vm.isLoadingHistory ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _vm._e(), _vm._l(_vm.refundRequestHistorySorted, function (historicRefundRequest) {
    return _c('refund-request', {
      attrs: {
        "refund-request": historicRefundRequest,
        "edit": false,
        "history": true
      },
      on: {
        "close": function ($event) {
          return _vm.$bvModal.hide(`editRefundRequest_${_vm.refundRequest.id}`);
        },
        "changed": function ($event) {
          return _vm.$emit('changed');
        }
      }
    });
  })], 2) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": `refundRequest-confirm-approve-${_vm.edit}-${_vm.refundRequest.id}`,
      "title": "Goedkeuren",
      "size": "md",
      "centered": "",
      "dialog-class": "shadow-none"
    },
    on: {
      "ok": _vm.approve
    }
  }, [_vm._v(" Weet je zeker dat je " + _vm._s(_vm._f("price")(_vm.totalRefundAmount)) + " wilt terugbetalen? ")]), _c('b-modal', {
    attrs: {
      "id": `refundRequest-confirm-deny-${_vm.edit}-${_vm.refundRequest.id}`,
      "title": "Weigeren",
      "size": "md",
      "centered": "",
      "dialog-class": "shadow-none"
    },
    on: {
      "ok": _vm.deny
    }
  }, [_vm._v(" Weet je zeker dat je deze creditering wilt weigeren? ")]), _c('b-modal', {
    attrs: {
      "id": `refundRequest-confirm-confirm-refund-to-be-processed-manually-${_vm.edit}-${_vm.refundRequest.id}`,
      "title": "Handmatige uitbetaling",
      "size": "md",
      "centered": "",
      "dialog-class": "shadow-none"
    },
    on: {
      "ok": _vm.confirmProcessed
    }
  }, [_vm._v(" Weet je zeker dat je de handmatig uitbetaling op verwerkt wilt zetten? ")]), _c('b-modal', {
    attrs: {
      "id": `refundRequest-confirm-cancel-automatic-processing-${_vm.edit}-${_vm.refundRequest.id}`,
      "title": "Annuleer automatische uitbetaling",
      "size": "md",
      "centered": "",
      "dialog-class": "shadow-none"
    },
    on: {
      "ok": _vm.confirmCancelAutomaticProcessing
    }
  }, [_vm._v(" Weet je zeker dat je de automatische uitbetaling wilt annuleren?"), _c('br'), _vm._v(" De uitbetaling zal worden omgezet naar 'te accorderen'. ")]), _c('b-modal', {
    attrs: {
      "id": `refundRequest-confirm-release-automatic-processing-${_vm.edit}-${_vm.refundRequest.id}`,
      "title": "Nu verwerken",
      "size": "md",
      "centered": "",
      "dialog-class": "shadow-none"
    },
    on: {
      "ok": _vm.confirmReleaseAutomaticProcessing
    }
  }, [_vm._v(" Weet je zeker dat je deze uitbetaling nu wilt laten verwerken? ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }